import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_pets_new_products: FaireCategoryEntity = {
  token: "cat_pets-new-products",
  type: "category",
  name: "New products",
  level: 2,
  parentToken: "cat_pets",
  href: "/category/pets/new-products",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
